module.exports = __webpack_public_path__ + "media/images/icon__point--white-5fafc066d1b4adc3aeaaacc2acb3f4fb.png";